import axios from "axios";
import { getStore, setStore } from "./storage";
import { router } from "../router/index";
import { Message } from "iview";
import Cookies from "js-cookie";
// 统一请求路径前缀http://192.168.31.175:81
let base = "";
let examApiUrl = process.env.VUE_APP_EXAM_API || "";

// 超时设定
axios.defaults.timeout = 50000;

let userInfo = JSON.parse(Cookies.get("userInfo") || "{}");

axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    Message.error("请求超时");
    return Promise.resolve(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    const data = response.data;
    //console.log("info:" + JSON.stringify(data));
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
      case 401:
        // 未登录 清除已登录状态
        Cookies.set("userInfo", "");
        setStore("accessToken", "");
        router.push("/login");
        break;
      case 403:
        // 没有权限
        if (data.info !== null) {
          Message.error(data.info);
        } else {
          Message.error("未知错误");
        }
        break;
      case 500:
        // 错误
        if (data.info !== null) {
          Message.error(data.info);
        } else {
          Message.error("未知错误");
        }
        break;
      default:
        return data;
    }

    return data;
  },
  (err) => {
    // 返回状态码不为200时候的错误处理
    var code = err.response.data.code;
    switch (code) {
      case 401:
      case 403:
        // 未登录 清除已登录状态
        Cookies.set("userInfo", "");
        setStore("accessToken", "");
        router.push("/login");
        break;
    }
    Message.error(err.response.data.info);
    return Promise.resolve(err);
  }
);

export const getRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "get",
    url: `${base}${url}`,
    params: params,
    headers: {
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};

export const postRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};
export const postFileRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,

    headers: {
      "Content-Type": "multipart/form-data;",
      Authorization: accessToken,
      processData: false, // 使数据不做处理
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};
export const putRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "put",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};

export const deleteRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "delete",
    url: `${base}${url}`,
    params: params,
    headers: {
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};

export const uploadFileRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "post",
    url: `${base}${url}`,
    params: params,
    headers: {
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};
export const postRequestByJson = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "post",
    url: `${examApiUrl}${url}`,
    data: params,
    headers: {
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};
export const postRequestByBlob = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "post",
    url: `${examApiUrl}${url}`,
    data: params,
    headers: {
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
    responseType: "blob",
  });
};

export const getRequestOfExam = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "get",
    url: `${examApiUrl}${url}`,
    params: params,
    headers: {
      Authorization: accessToken,
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};
export const getFileRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: "get",
    url: `${examApiUrl}${url}`,
    params: params,
    responseType: "blob", //二进制流
    timeout: 10 * 60 * 1000,
    headers: {
      Authorization: accessToken,
      "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
      accountId: JSON.parse(Cookies.get("userInfo") || "{}").id,
      deptId: JSON.parse(Cookies.get("userInfo") || "{}").groupId,
      offSpring: JSON.parse(Cookies.get("userInfo") || "{}").offSpring,
    },
  });
};
